import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  preset: {
    id: 'core.pivotReport.preset',
    defaultMessage: 'Preset {name}',
  },
  openPreset: {
    id: 'core.pivotReport.openPreset',
    defaultMessage: 'Open preset',
  },
  savePreset: {
    id: 'core.pivotReport.savePreset',
    defaultMessage: 'Save preset',
  },
  overwritePreset: {
    id: 'core.pivotReport.overwritePreset',
    defaultMessage: 'Overwrite an existing preset "{name}"?',
  },
  label: {
    id: 'core.pivotReport.presetInputLabel',
    defaultMessage: 'Preset name',
  },
  orientationSelectorTitle: {
    id: 'core.pivotReport.otientation.title',
    defaultMessage: 'Select the page orientation',
  },
});
